import { UsageReport } from '@/billing/UsageReport'

export function BillingReports() {
  return <UsageReport />
}
